import Vue from 'vue'
import router from './router'
import store from './store'
import VueBootstrap from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
// import VueNVD3 from 'vue-nvd3'
import VueInsProgressBar from 'vue-ins-progress-bar'
// import VueEventCalendar from 'vue-event-calendar'
// import VueSparkline from 'vue-sparklines'
// import * as VueGoogleMaps from 'vue2-google-maps'
// import Vueditor from '@agametov/vueditor'
// import VueHljs from 'vue-hljs'
// import VueSweetalert2 from 'vue-sweetalert2'
// import VueNotification from 'vue-notification'
import VuePanel from './plugins/panel/'
// import VueDateTimePicker from 'vue-bootstrap-datetimepicker'
// import VueSelect from 'vue-select'
// import VueDatepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
// import VueMaskedInput from 'vue-maskedinput'
// import VueInputTag from 'vue-input-tag'
// import VueSlider from 'vue-slider-component'
// import VueGoodTable from 'vue-good-table'
// import VueFullCalendar from 'vue-full-calendar'
// import VueCountdown from '@xkeshi/vue-countdown'
// import VueColorpicker from 'vue-pop-colorpicker'
import VueSlimScroll from 'vue-slimscroll'
import moment from 'moment'
import Vmodal from 'vue-js-modal'
import VTooltip from 'v-tooltip'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// use a new library ant-vue-desing
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import './style/main.scss'

import './components/common'
import App from './App.vue'
import { Toast, ModalDialog } from './plugins'
import i18n from './i18n'

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VueClipboard)
Vue.use(VueBootstrap)
Vue.use(VueCroppie)
Vue.use(VueLazyload)
Vue.use(Vuelidate)
// Vue.use(VueNVD3)
// Vue.use(VueEventCalendar, { locale: 'en' })
// Vue.use(VueSparkline)
// Vue.use(Vueditor)
// Vue.use(VueHljs)
// Vue.use(VueSweetalert2)
// Vue.use(VueNotification)
Vue.use(VuePanel)
Vue.use(VuePanel)
// Vue.use(VueDateTimePicker)
// Vue.use(VueGoodTable)
// Vue.use(VueFullCalendar)
// Vue.use(VueColorpicker)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBRIToqK1-GDMqfN-imvB2SJS8zmlXnVXQ',
    libraries: 'places',
    language: 'km'
  }
})
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
Vue.use(VueSlimScroll)
// Vue.component('v-select', VueSelect)
// Vue.component('datepicker', VueDatepicker)
// Vue.component('masked-input', VueMaskedInput)
// Vue.component('input-tag', VueInputTag)
// Vue.component('vue-slider', VueSlider)
// Vue.component(VueCountdown.name, VueCountdown)
Vue.component('treeselect', Treeselect)
Vue.use(Toast, { position: 'top-right', duration: 2000 })
Vue.use(ModalDialog)
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })
Vue.use(VTooltip)

moment.locale('en', {
  week: {
    dow: 1
  }
})

new Vue({
  router,
  store,
  i18n,
  data: {
    appName: process.env.VUE_APP_NAME
  },
  render: h => h(App)
}).$mount('#app')
